import React, { useEffect, useState } from 'react';
import { db } from '../../../config/firebase';
import {
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { GetApp, PlayArrow } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 10,
    background: '#FFFFFF',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e0e0e0',
  },
  header: {
    marginBottom: theme.spacing(1),
  },
  list: {
    maxHeight: 300,
    overflowY: 'auto',
  },
}));

export const HistoricalChatsPanel = ({ username, onContinueChat, onDownloadError }) => {
  const classes = useStyles();
  const [chatTitles, setChatTitles] = useState([]);
  const [downloadingChat, setDownloadingChat] = useState(null);

  useEffect(() => {
    if (!username) return;
    const addr = `${username}`;
    const unsubscribe = db
      .collection(addr)
      .doc('japyChats')
      .onSnapshot((doc) => {
        if (doc.exists) {
          const data = doc.data();
          setChatTitles(Array.isArray(data.historyChats) ? data.historyChats : []);
        }
      });
    return () => unsubscribe();
  }, [username]);

  const handleDownloadSingle = async (nameChat) => {
    setDownloadingChat(nameChat);
    try {
      const payload = { username, nameChat };
      const response = await fetch('https://us-central1-gapy-c999c.cloudfunctions.net/getHistoricalChats', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error(`Fallo la descarga de ${nameChat}`);
      const json = await response.json();
      // Abrir el enlace de descarga en una nueva pestaña
      window.open(json.url, '_blank');
    } catch (err) {
      onDownloadError && onDownloadError('No se pudo obtener el link de descarga.');
    }
    setDownloadingChat(null);
  };

  return (
    <Card className={classes.card}>
      <CardContent>
        <Grid container alignItems="center" justifyContent="space-between" className={classes.header}>
          <Grid item>
            <Typography variant="h6">Historial de chats</Typography>
          </Grid>
        </Grid>

        <Divider />

        <List dense className={classes.list}>
          {chatTitles.length === 0 && (
            <ListItem>
              <ListItemText primary="Aún no hay chats. Realiza un análisis para comenzar." />
            </ListItem>
          )}
          {chatTitles.map((title) => (
            <ListItem key={title}>
              <ListItemText primary={title} />
              <ListItemSecondaryAction>
                <Tooltip title="continuar Chat" arrow>
                  <IconButton edge="end" aria-label="continuar" onClick={() => onContinueChat && onContinueChat(title)}>
                    <PlayArrow />
                  </IconButton>
                </Tooltip>
                <Tooltip title="descargar Chat" arrow>
                  <IconButton 
                    edge="end" 
                    aria-label="descargar" 
                    onClick={() => handleDownloadSingle(title)}
                    disabled={downloadingChat === title}
                  >
                    <GetApp color={downloadingChat === title ? 'disabled' : 'primary'} />
                  </IconButton>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>

      </CardContent>
    </Card>
  );
};


